// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3C_Wv","loaderOuter":"PageOverlayLoader_loaderOuter__1id8j"};